/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente__A_95_65(e) {
  let t = (0, ReactCompiler.c)(8),
    { titulo: n, valor: r, alerta: i } = e,
    a = i !== void 0 && i,
    o;
  t[0] === n
    ? (o = t[1])
    : ((o = <span className={`text-xs text-(--text)`} children={n} />),
      (t[0] = n),
      (t[1] = o));
  let s = a ? `font-medium text-(--error)` : `text-(--text-h)`,
    c;
  t[2] !== s || t[3] !== r
    ? ((c = <span className={s} children={r} />),
      (t[2] = s),
      (t[3] = r),
      (t[4] = c))
    : (c = t[4]);
  let l;
  return (
    t[5] !== o || t[6] !== c
      ? ((l = (
          <li
            className={`flex items-baseline justify-between gap-2 border-b border-(--border)/60 py-1`}
            children={[o, c]}
          />
        )),
        (t[5] = o),
        (t[6] = c),
        (t[7] = l))
      : (l = t[7]),
    l
  );
}
